import * as React from 'react';

export interface IIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

/** Wraps an @untitledui/icons component and defaults strokeWidth to 1.7. */
export function createIcon(Component: React.FC<IIconProps>): React.FC<IIconProps> {
  function Icon({ strokeWidth = 1.7, ...props }: IIconProps) {
    return <Component strokeWidth={strokeWidth} {...props} />;
  }
  Icon.displayName = Component.displayName ?? Component.name;
  return Icon;
}
